import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import test from './reducers/test'
import user from './reducers/user'
import pendingTasks from './reducers/pendingTasks'

const rootReducer = combineReducers({
  testInReducer: test,
  userInReducer: user,
  pendingTasks: pendingTasks
})

export default function configureStore () {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const store = createStore(rootReducer,
    undefined,
    composeEnhancers(
      applyMiddleware(thunk)
    )
  )
  return store
}
